










































































import { IInvoiceProvider } from "@/models/providers/invoice";
import { Component, Vue } from "vue-property-decorator";
import TransactionsProvider from "@/components/app/admin/transactions/transactionsProvider.vue";

@Component({
  components: {
    "invoice-provider": () =>
      import("@/components/app/global/invoices/invoiceProvider.vue"),
    "invoice-details": () =>
      import("@/components/app/global/invoices/invoiceDetails.vue"),
    "credit-note-actions": () =>
      import("@/components/app/global/invoices/creditNoteActions.vue"),
    "transactions-listing": () =>
      import("@/components/app/admin/transactions/transactionsListing.vue"),
    "timeline-table": () =>
      import("@/components/app/global/timelineComponent/timelineTable.vue"),
    TransactionsProvider
  }
})
export default class AdminClientCreditNoteView extends Vue {
  // Refs
  public $refs!: {
    transactionsProvider: TransactionsProvider;
  };

  public invoiceId = this.$route.params.invoiceId;

  public onNotFound(vm: IInvoiceProvider & Vue) {
    return vm.$router
      .push({ name: "adminClientCreditNotes" })
      .catch(err => err);
  }

  public refreshTransactions() {
    this.$refs?.transactionsProvider?.reloadData();
  }
}
